<template>
  <Modal v-model="billSkuDetailsModal" :title="$t('key1003958')" width="600" :transfer="false" @on-visible-change="billSkuDetailsChange">
    <h2 class="mb10 flex align-items-center">
      <span>{{ $t('key1003959') }}</span>
      <span>{{ skuCategoryNum }}</span>
      <span>{{ $t('key1003960') }}</span>
      <span>{{ skuTotal }}</span>
      <span>{{ $t('key1003961') }}</span>
    </h2>
    <Form ref="pageParams" :model="pageParams" :label-width="80" @submit.native.prevent>
      <Row type="flex" :gutter="gutterItem">
        <Col span="16">
          <Form-item :label="configCharacters(false) + 'SKU：'" prop="skus">
            <Input :placeholder="$t('key1003956')+ configCharacters(false) + $t('key1003957')" type="textarea" v-model.trim="pageParams.skus"></Input>
          </Form-item>
        </Col>
        <Col style="min-width: 190px;" push="1">
          <Button @click="reset" class="mr12">{{ $t('key1000109') }}</Button>
          <Button type="primary" @click="search">{{ $t('key1000361') }}</Button>
        </Col>
      </Row>
    </Form>
    <div class="table_box">
      <Table
        highlight-row
        border
        max-height="450"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
      </Table>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="pageParams.pageNum"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>
    <template #footer>
      <Button type="primary" @click="billSkuDetailsModal = false">{{ $t('key1000316') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';

export default {
  name: "billSkuDetailsModal",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      billSkuDetailsModal: false,
      tableColumns: [
        {
          type: 'index',
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000343'),
          width: 70,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000239'),
          key: 'skuInfo',
          align: 'left',
          minWidth: 200,
          render(h, params) {
            let imgPath = '';
            let spec = '';
            let skuImgPath = params.row._productInfo.primaryImage;
            let spuImgPath = params.row._productInfo._spuInfo.primaryImage;
            imgPath = skuImgPath ? skuImgPath : spuImgPath;
            let title = params.row._productInfo._spuInfo.name;
            let ymsSku = params.row._productInfo.ymsSku;
            if (params.row._productInfo.productGoodsSpecificationList) {
              spec = params.row._productInfo.productGoodsSpecificationList.map(i => i.name + '：' + i.value).join('、');
            }
            return h('div', {class: 'flex mt5 mb5'}, [
              v.tableImg(h, params, null, imgPath),
              h('div', {class: 'ml5'}, [
                h('div', {class: 'flex align-items-start mb5'}, [
                  h('p', {
                    style: {
                      width: '70px',
                      textAlign: 'right'
                    }
                  }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000100')),
                  h('p', {
                    style: {
                      flex: 1
                    }
                  }, title),
                ]),
                h('div', {class: 'flex align-items-start mb5'}, [
                  h('p', {
                    style: {
                      width: '70px',
                      textAlign: 'right'
                    }
                  }, 'SKU：'),
                  h('p', {
                    style: {
                      flex: 1
                    }
                  }, ymsSku),
                ]),
                h('div', {class: 'flex align-items-start mb5'}, [
                  h('p', {
                    style: {
                      width: '70px',
                      textAlign: 'right'
                    }
                  }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000240')),
                  h('p', {
                    style: {
                      flex: 1
                    },
                    class: 'color-green'
                  }, spec),
                ]),
              ])
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000523'),
          key: 'quantity',
          align: 'left'
        }
      ],
      tableData: [],
      total: 0,
      pageParams: {
        pageNum: 1,
        pageSize: 15,
        skus: '',
        ymsPickupOrderId: null
      },
      skuCategoryNum: 0,
      skuTotal: 0
    };
  },
  methods: {
    // 初始化数据
    initBillSkuDetailsData(data) {
      let v = this;
      v.pageParams.ymsPickupOrderId = data.ymsPickupOrderId;
      v.skuCategoryNum = data.skuCategoryNum;
      v.skuTotal = data.skuTotal;
      v.search();
      v.billSkuDetailsModal = true;
    },
    // 重置
    reset() {
      this.pageParams.pageNum = 1;
      this.pageParams.pageSize = 15;
      this.pageParams.skus = '';
      this.search();
    },
    // 查询
    search() {
      this.pageParams.pageNum = 1;
      this.pageParamsStatus = true;
    },
    // 获取列表数据
    getList() {
      let v = this;
      let params = Object.assign({}, v.pageParams);
      params.skus = v.sepCommasFn(v.pageParams.skus, ['\n']);
      v.tableLoading = true;
      v.axios.post(api.post_ymsPickupOrder_pickupOrderSkuDetail, params, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
        v.tableLoading = false;
        if (res.data.code === 0) {
          let data = res.data.datas;
          let list = data.list || [];
          v.total = data.total;
          if (list.length > 0) {
            let ymsProductGoodsIds = [];
            list.map((item) => {
              ymsProductGoodsIds.push(item.ymsProductGoodsId);
            });
            if (ymsProductGoodsIds.length > 0) {
              (async () => {
                v.tableData = await v.getProductInfoByIds(ymsProductGoodsIds, list);
              })();
            }
          }
        }
      });
    },
    // 监听弹窗
    billSkuDetailsChange(value) {
      if (!value) {
        this.tableData = [];
        this.$refs['pageParams'].resetFields();
        this.skuCategoryNum = 0;
        this.skuTotal = 0;
      }
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
};
</script>

<style scoped>

</style>
